import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AzureLoggerService } from './AzureLoggerService';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    public constructor(
        private _toastr: ToastrService,
        private _logger: AzureLoggerService,
    ) {}

    public intercept(
        req: HttpRequest<unknown>,
        next: HttpHandler,
    ): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                this._logger.logException(error);
                this._toastr.error(this._buildMessage(error), 'Request failed', {
                    timeOut: 7000,
                    closeButton: true,
                });
                return throwError(() => error);
            }),
        );
    }

    private _buildMessage(error: HttpErrorResponse): string {
        const url = this._shortUrl(error.url);
        switch (error.status) {
            case 0:
                return `Network error — could not reach the server (${url}).`;
            case 401:
                return `You are not authorized (${url}).`;
            case 403:
                return `Access denied (${url}).`;
            case 404:
                return `Resource not found (${url}).`;
            default:
                if (error.status >= 500) {
                    return `Server error ${error.status} while loading ${url}.`;
                }
                return `${error.status} ${error.statusText || ''} — ${url}`.trim();
        }
    }

    private _shortUrl(url: string | null): string {
        if (!url) return 'request';
        try {
            return new URL(url).pathname;
        } catch {
            return url;
        }
    }
}
